import {
  COMPANY_STATUS, COMPANY_STATUS_ERROR, COMPANY_STATUS_SUCCESS,
  DELETE_ORGANIZATION,
  DELETE_ORGANIZATION_FAIL,
  DELETE_ORGANIZATION_SUCCESS,
  DOWNLOAD,
  DOWNLOAD_ERROR,
  DOWNLOAD_SUCCESS,
  GET_COMPANY_DETAIL, GET_COMPANY_DETAIL_ERROR, GET_COMPANY_DETAIL_SUCCESS,
  GET_ONE_COMPANY_DETAIL,
  GET_ONE_COMPANY_DETAIL_ERROR,
  GET_ONE_COMPANY_DETAIL_SUCCESS,
  NEW_COMPANY_ADD, NEW_COMPANY_ADD_ERROR, NEW_COMPANY_ADD_SUCCESS
} from "./actionTypes"

export const getCompanyDetails = (data) => {
    return {
      type: GET_COMPANY_DETAIL,
      payload: data
    }
  }
  
  export const getCompanyDetailsSuccess = data => {
    return {
      type: GET_COMPANY_DETAIL_SUCCESS,
      payload: data 
    }
  }
  
  export const getCompanyDetailsError = data => {
    return {
      type: GET_COMPANY_DETAIL_ERROR,
      payload: data
    }
  }

  export const getOneCompanyDetails = (data) => {
    return {
      type: GET_ONE_COMPANY_DETAIL,
      payload: data
    }
  }
  
  export const getOneCompanyDetailsSuccess = data => {
    return {
      type: GET_ONE_COMPANY_DETAIL_SUCCESS,
      payload: data 
    }
  }
  
  export const getOneCompanyDetailsError = data => {
    return {
      type: GET_ONE_COMPANY_DETAIL_ERROR,
      payload: data
    }
  }

  export const addNewComapny = (data) => {
    return {
      type: NEW_COMPANY_ADD,
      payload: data
    }
  }
  
  export const addNewComapnySuccess = data => {
    return {
      type: NEW_COMPANY_ADD_SUCCESS,
      payload: data 
    }
  }
  
  export const addNewComapnyError = data => {
    return {
      type: NEW_COMPANY_ADD_ERROR,
      payload: data
    }
  }

  export const companyStatus = (data) => {
    return {
      type: COMPANY_STATUS,
      payload: data
    }
  }
  
  export const companyStatusSuccess = data => {
    return {
      type: COMPANY_STATUS_SUCCESS,
      payload: data 
    }
  }
  
  export const companyStatusError = data => {
    return {
      type: COMPANY_STATUS_ERROR,
      payload: data
    }
  }

  export const download = (data) => {
    return {
      type: DOWNLOAD,
      payload: data 
    }
  }
  
  export const downloadSuccess = data => {
    return {
      type: DOWNLOAD_SUCCESS,
      payload: data 
    }
  }
  
  export const downloadError = data => {
    return {
      type: DOWNLOAD_ERROR,
      payload: data
    }
  }

  export const deleteOrganization = data => {
    return{
      type: DELETE_ORGANIZATION,
      payload: data
    }
  }

  export const deleteOrganizationSuccess = data => {
    return{
      type: DELETE_ORGANIZATION_SUCCESS,
      payload: data
    }
  }

  export const deleteOrganizationFail = data => {
    return{
      type: DELETE_ORGANIZATION_FAIL,
      payload: data
    }
  }